import { createFileRoute, redirect } from '@tanstack/react-router'
import { Parkir } from '../pages/Parkir'

export const Route = createFileRoute('/parkir')({
  beforeLoad: async () => {
    try {
      const res = await fetch('/api/users/me', { credentials: 'include' })
      if (!res.ok) throw new Error('not authenticated')
      const user = await res.json()
      if (!user) throw new Error('no user')

      // platform_admin / qc → platform dashboard
      if (user.role === 'platform_admin' || user.is_qc) {
        throw redirect({ to: '/platform' })
      }

      // approved staff → desa dashboard
      const staffRoles = ['kepala_desa', 'sekretaris_desa', 'operator_desa']
      if (staffRoles.includes(user.role) && user.status === 'approved' && user.desa?.slug) {
        throw redirect({ to: `/desa/${user.desa.slug}/dashboard` as any })
      }

      // pending tanpa desa → pilih desa (kecuali admin request)
      if (user.status === 'pending' && !user.desa_id && !user.admin_request) {
        throw redirect({ to: '/pilih-desa' })
      }

      // pending dengan desa → overview desa
      if (user.status === 'pending' && user.desa?.slug) {
        throw redirect({ to: `/desa/${user.desa.slug}` as any })
      }
    } catch (e) {
      if ((e as any)?.to) throw e
      throw redirect({ to: '/login' })
    }
  },
  component: Parkir,
})
